export enum OutWarehouseFlgEnum {
  NOT_EXIST_OUT_WAREHOUSE = '0',
  EXIST_OUT_WAREHOUSE = '1',
}
